"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISABLE = exports.ENABLE = void 0;
var ENABLE = 'partnerEmulation/ENABLE';
exports.ENABLE = ENABLE;
var DISABLE = 'partnerEmulation/DISABLE';
exports.DISABLE = DISABLE;